:root {
  --text: #6b6375;
  --text-h: #08060d;
  --bg: #fff;
  --border: #e5e4e7;
  --code-bg: #f4f3ec;
  --accent: #1b3a6b;
  --accent-bg: rgba(27, 58, 107, 0.1);
  --accent-border: rgba(27, 58, 107, 0.5);
  --social-bg: rgba(244, 243, 236, 0.5);
  --shadow:
    rgba(0, 0, 0, 0.1) 0 10px 15px -3px, rgba(0, 0, 0, 0.05) 0 4px 6px -2px;

  --sans: system-ui, 'Segoe UI', Roboto, sans-serif;
  --heading: system-ui, 'Segoe UI', Roboto, sans-serif;
  --mono: ui-monospace, Consolas, monospace;

  font: 18px/145% var(--sans);
  letter-spacing: 0.18px;
  color-scheme: light dark;
  color: var(--text);
  background: var(--bg);
  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  /* Mobile-First Responsive Design */
  @media (max-width: 1024px) {
    font-size: 16px;
  }
  
  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 1.5;
  }
  
  @media (max-width: 480px) {
    font-size: 14px;
    line-height: 1.4;
  }
}

@media (prefers-color-scheme: dark) {
  :root {
    --text: #9ca3af;
    --text-h: #f3f4f6;
    --bg: #16171d;
    --border: #2e303a;
    --code-bg: #1f2028;
    --accent: #4d7cfe;
    --accent-bg: rgba(77, 124, 254, 0.15);
    --accent-border: rgba(77, 124, 254, 0.5);
    --social-bg: rgba(47, 48, 58, 0.5);
    --shadow:
      rgba(0, 0, 0, 0.4) 0 10px 15px -3px, rgba(0, 0, 0, 0.25) 0 4px 6px -2px;
  }

  #social .button-icon {
    filter: invert(1) brightness(2);
  }
}

/* Mobile-Specific Optimizations */
* {
  -webkit-tap-highlight-color: transparent;
  box-sizing: border-box;
}

/* Touch-friendly interactions */
button, [role="button"], input, select, textarea {
  min-height: 44px; /* iOS minimum touch target */
  min-width: 44px;
}

/* Prevent zoom on input focus (iOS) */
@media screen and (max-width: 768px) {
  input, select, textarea {
    font-size: 16px; /* Prevents zoom on iOS */
  }
}

/* Optimize for mobile gestures */
.scrollable {
  -webkit-overflow-scrolling: touch;
  overflow-scrolling: touch;
}

/* Better mobile typography */
@media (max-width: 768px) {
  h1 { font-size: 1.8rem; }
  h2 { font-size: 1.5rem; }
  h3 { font-size: 1.3rem; }
  
  /* Increase line spacing for readability */
  p, li {
    line-height: 1.6;
  }
  
  /* Better spacing for mobile */
  .container {
    padding: 1rem;
  }
  
  /* Ensure content doesn't get too close to edges */
  body {
    padding: 0 1rem;
  }
}

/* Landscape orientation adjustments */
@media screen and (orientation: landscape) and (max-height: 500px) {
  :root {
    font-size: 14px;
  }
}

/* Hide scrollbars on mobile while keeping functionality */
@media (max-width: 768px) {
  ::-webkit-scrollbar {
    display: none;
  }
  
  * {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
}

#root {
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  text-align: center;
  min-height: 100svh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  @media (min-width: 481px) {
    border-inline: 1px solid var(--border);
  }
}

body {
  margin: 0;
}

h1,
h2 {
  font-family: var(--heading);
  font-weight: 500;
  color: var(--text-h);
}

h1 {
  font-size: 56px;
  letter-spacing: -1.68px;
  margin: 32px 0;
  @media (max-width: 1024px) {
    font-size: 36px;
    margin: 20px 0;
  }
}
h2 {
  font-size: 24px;
  line-height: 118%;
  letter-spacing: -0.24px;
  margin: 0 0 8px;
  @media (max-width: 1024px) {
    font-size: 20px;
  }
}
p {
  margin: 0;
}

code,
.counter {
  font-family: var(--mono);
  display: inline-flex;
  border-radius: 4px;
  color: var(--text-h);
}

code {
  font-size: 15px;
  line-height: 135%;
  padding: 4px 8px;
  background: var(--code-bg);
}
